import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AgroAssistApp from './AgroAssistApp';
import './i18n';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AgroAssistApp />
  </React.StrictMode>
);
